export default __webpack_public_path__ + "static/media/dj.98f6e262.svg";